import { useTheme } from '@mui/material';
import { darken } from '@mui/material/styles';
import EChartsReact from 'echarts-for-react';
import React from 'react';
import { getValueFromPercent } from 'utils/helpers';
interface IProps {
    showLabel: boolean;
    total: number;
    info: {
        data: [number, number, number][];
        row: string[];
        col: string[];
    };
}
const QuestionHeatMapChart: React.FC<IProps> = ({ showLabel, info, total }) => {
    const theme = useTheme();
    const dataNew = info?.data?.map(function (item) {
        return [item[1], item[0], item[2] || '-'];
    });
    return (
        <EChartsReact
            key={info.row.length}
            notMerge={true}
            style={{ height: 600 }}
            option={{
                tooltip: {
                    position: 'top',
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    formatter: function (params: any) {
                        const { data, name } = params;
                        const [x, y, value] = data;
                        return `
        <div>
          <b>${name}</b><br/>
          x: ${x} | y: ${y}<br/>
          <b>${getValueFromPercent(value, total, 0)}</b>
        </div>
      `;
                    },
                },
                grid: {
                    top: '10%',
                    left: '3%',
                    right: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: info?.row ?? [],
                    splitArea: {
                        show: true,
                    },
                },
                yAxis: {
                    type: 'category',
                    data: info?.col ?? [],
                    splitArea: {
                        show: true,
                    },
                },
                visualMap: {
                    min: 0,
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    bottom: '15%',
                    inRange: {
                        color: [
                            '#F0E6FF',
                            '#D5BFFF',
                            '#BB99FF',
                            '#A073FF',
                            '#854DFF',
                            theme.palette.primary.main,
                            darken(theme.palette.primary.main, 0.15),
                            '#5000CC',
                            '#4200B3',
                            '#350099',
                        ],
                    },
                    show: false,
                },

                series: [
                    {
                        name: '',
                        type: 'heatmap',
                        data: dataNew ?? [],
                        label: {
                            show: showLabel,
                            color: '#000',
                            fontSize: 12,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            formatter: function (params: any) {
                                const { data } = params;
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const [x, y, value] = data;
                                return `${value}%`;
                            },
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            }}
        />
    );
};

export default QuestionHeatMapChart;
